<template>
  <div style="position: relative">
    <unicom-area-texto
      ref="area-edicao"
      :textAreaStyleProp="{
        'font-size': '16px',
        'line-height': '18px',
        padding: '14px 16px',
        'max-height': '100px'
      }"
      max="350"
      mostrarContador
      alturaAutomatica
      placeholder="Insira a observação..."
      v-model="observacaoData"
      prevenirEnter
      @tecla-pressionada="teclaPressionada"
    />
    <div class="mt-2 segunda-cor-fonte texto" style="position: absolute">
      Aperte Esc para
      <span class="hover-underline" @click="objetosTeclas.Escape">
        cancelar</span
      >
      ou Enter para
      <span class="hover-underline" @click="objetosTeclas.Enter"> salvar</span>.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    observacao: {
      type: String,
      default: ""
    },
    alturaCartao: {
      type: Number,
      default: 137
    }
  },
  data() {
    return {
      observacaoData: this.observacao,
      objetosTeclas: {
        Enter: () => {
          this.$emit("salvar-observacao", this.observacaoData);
        },
        Escape: () => {
          this.$emit("editar", false);
        }
      }
    };
  },
  mounted() {
    this.$refs["area-edicao"].$refs.textarea.focus();
  },
  methods: {
    /**
     * @param {KeyboardEvent} event
     */
    teclaPressionada(event) {
      const tecla = event.code || event.key;

      if (!Object.keys(this.objetosTeclas).includes(tecla)) return;
      if (event.shiftKey && tecla === "Enter") return;

      this.objetosTeclas[tecla]();
    }
  },
  watch: {
    observacao() {
      this.observacaoData = this.observacao;
    }
  }
};
</script>
